import { formatDuration, getLatestByDate, sumByKey } from './analytics.helpers';

export const mapAnalyticsData = ({ overviewResponse, pageName }) => {
  const overviewData = overviewResponse?.data ?? {};

  const total = Array.isArray(overviewData.total) && overviewData.total.length > 0
    ? overviewData.total[0]
    : null;

  const visits = total?.visits ?? sumByKey(overviewData.visits, 'visits');
  const views = total?.views ?? sumByKey(overviewData.views, 'views');
  const uniqueVisitors = total?.users ?? sumByKey(overviewData.users, 'new');
  const visitsCharts = Array.isArray(overviewData.visits) ? overviewData.visits : [];
  const uniqueVisitorsCharts = Array.isArray(overviewData.users)
    ? overviewData.users.map(({ date, new: newUsers }) => ({
        date,
        views: Number(newUsers) || 0,
      }))
    : [];

  const latestUser = getLatestByDate(overviewData.users);

  return {
    visits,
    uniqueVisitors,
    visitsCharts,
    uniqueVisitorsCharts,
    tableRows: [
      {
        page: pageName,
        views,
        timeOnPage: formatDuration(latestUser?.newDuration),
      },
    ],
  };
};
